{
  "WALLBOARD": {
    "LOADING": "Ladataan puhelinjonoja...",
    "NO_QUEUES": "Puhelinjonoja ei löytynyt.",
    "NO_AGENTS": "Tässä jonossa ei ole paikalla olevia edustajia.",
    "UNKNOWN_CALLER": "Tuntematon soittaja",
    "STATUS": "Tila",
    "TIME": "Aika",
    "AGENT": "Edustaja",
    "EXTENSION": "Alanumero",
    "READY": "Valmiit edustajat",
    "ON_CALL": "Puhelussa olevat edustajat",
    "PAUSED": "Tauolla olevat edustajat",
    "WAITING": "Odottavat puhelut",
    "MISSED_CALLS": "Vastaamattomat puhelut",
    "HANDLED_CALLS": "Käsitellyt saapuvat puhelut",
    "OUTBOUND_CALLS": "Käsitellyt lähtevät puhelut",
    "AVAILABILITY": "Saatavuus",
    "AVAILABILITY_TOOLTIP": "Osuus saapuvista puheluista, joihin edustajat vastasivat (vastatut puhelut)",
    "AGENTS_COUNT": "({onCall} puhelussa / {total} yhteensä)",
    "NO_AVAILABLE": "(ei ketään paikalla)",
    "WAITING_CALLERS_COUNT": "{count} odottaa",
    "CALLER": "Soittaja",
    "NUMBER": "Numero",
    "WAIT_TIME": "Odotusaika",
    "ACTION": "Toiminto",
    "PICKUP_CALL": "Ota vastaan",
    "PICKUP_SUCCESS": "Puhelun vastaanottopyyntö lähetetty onnistuneesti.",
    "PICKUP_ERROR": "Puhelun vastaanotto epäonnistui. Yritä uudelleen.",
    "PICKUP_DISABLED_TOOLTIP": "Et voi ottaa puhelua vastaan, kun olet toisessa puhelussa tai poissa linjoilta.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Ei käyttöoikeutta"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Ei käyttöoikeutta"
    }
  }
}
